<template>
  <Fullcalendar ref="fullCalendar" :options="calendarOptions" />
</template>

<script>
import Fullcalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MiniCalendar",
  components: {
    Fullcalendar,
  },
  props: {
    initialView: String,
    type: String,
    headerToolbar: String,
  },
  data() {
    return {
      events: [],
    };
  },
  computed: {
    ...mapGetters(["userSessionAll", "trainerSessionAll"]),

    calendarOptions() {
      return {
        ...this.options,
        ...this.handlers,
      };
    },

    options() {
      return {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        headerToolbar: {
          left: "prev,next",
          center: this.headerToolbar,
          right: "title",
        },
        initialView: this.initialView,
        events: this.events,
        editable: true,
        selectable: true,
        allDaySlot: false,
        navLinks: true,
        moreLinkClick: "week",
        dayMaxEventRows: true,
        views: {
          dayGrid: {
            dayMaxEventRows: 2,
          },
        },
        showNonCurrentDates: true,
        // height: window.screen.availHeight / 3,
      };
    },

    handlers() {
      return {
        eventConstraint: {
          start: new Date(),
        },
        eventOverlap: function (stillEvent, movingEvent) {
          return stillEvent.allDay && movingEvent.allDay;
        },
        eventMouseEnter: function (element) {
          element.el.setAttribute("title", element.event.title);
        },
      };
    },
  },
  methods: {
    ...mapActions(["getUserSessionAll", "getTrainerSessionAll"]),
  },
  async created() {
    if (this.type == "user") {
      await this.getUserSessionAll();
      this.userSessionAll.forEach((ele) => {
        //converting Recur to local string to the day tome also matchced.
        ele.startRecur = this.utcToLocalWithFormat(ele.startRecur, false);
        ele.endRecur = this.utcToLocalWithFormat(ele.endRecur, false);
        //start date
        ele.startTime = this.utcToLocalWithFormat(ele.startTime);
        //end date
        ele.endTime = this.utcToLocalWithFormat(ele.endTime);
        //Session images
        // ele.imageurl = this.baseUrlSrc(ele.thumbnailUrl);
      });
      this.events = this.userSessionAll;
    } else {
      await this.getTrainerSessionAll();
      this.trainerSessionAll.forEach((ele) => {
        ele.startRecur = this.utcToLocalWithFormat(ele.startRecur, false);
        ele.endRecur = this.utcToLocalWithFormat(ele.endRecur, false);
        //start date
        ele.startTime = this.utcToLocalWithFormat(ele.startTime);
        //end date
        ele.endTime = this.utcToLocalWithFormat(ele.endTime);
      });
      this.events = this.trainerSessionAll;
    }
  },
};
</script>

<style>
.mini-calendar .fc-scrollgrid {
  border: none !important;
}
.mini-calendar .fc-daygrid-day-events {
  float: right;
}
.mini-calendar .fc-daygrid-day-events {
  min-height: unset !important;
  display: flex;
  flex-wrap: wrap;
}
.mini-calendar .fc-daygrid-event-harness .fc-event-time,
.mini-calendar .fc-daygrid-event-harness .fc-event-title,
.mini-calendar .fc-daygrid-day-bottom {
  display: none;
}
.mini-calendar .fc-daygrid-event-dot {
  border: 2px solid;
  margin: 0 0px !important;
}
.mini-calendar .fc-scroller {
  overflow-y: hidden !important;
}
.mini-calendar .fc .fc-button-primary {
  border: unset;
}
.mini-calendar .fc td,
.fc th {
  border: unset !important;
}
.mini-calendar .fc .fc-button-primary:active:focus {
  outline: none;
  box-shadow: none;
}
.mini-calendar .fc .fc-button-primary:focus {
  outline: none;
  box-shadow: none;
}
.mini-calendar,
.fc-theme-standard td,
.fc-theme-standard th {
  border: unset;
}
@media only screen and (max-width: 420px) {
  .mini-calendar .fc-scroller {
    overflow-y: visible !important;
  }
}
</style>